import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Divider from "@mui/material/Divider";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import parseISO from "date-fns/parseISO";
import formatDistanceToNow from "date-fns/formatDistanceToNow";

const Information = ({
  userData: {
    attributes: { created_at, role },
  },
}) => {
  return (
    <Box bgcolor={"alternate.main"}>
      <List
        sx={{
          width: "100%",
          bgcolor: "background.paper",
          padding: 2,
          borderRadius: 2,
          boxShadow: 2,
        }}
      >
        <ListItem alignItems={"flex-start"}>
          <ListItemAvatar>
            <CalendarMonthIcon />
          </ListItemAvatar>
          <ListItemText
            primary={"Account created"}
            primaryTypographyProps={{ fontWeight: 800 }}
            secondary={
              <Typography
                sx={{ display: "inline" }}
                component={"span"}
                variant={"body2"}
                color={"text.primary"}
              >
                {formatDistanceToNow(parseISO(created_at), {
                  addSuffix: true,
                })}
              </Typography>
            }
          />
        </ListItem>
        <Divider variant="inset" component="li" />
        <ListItem alignItems={"flex-start"}>
          <ListItemAvatar>
            <AdminPanelSettingsIcon />
          </ListItemAvatar>
          <ListItemText
            primary={"Role"}
            primaryTypographyProps={{ fontWeight: 800 }}
            secondary={
              <Typography
                sx={{ display: "inline" }}
                component={"span"}
                variant={"body2"}
                color={"text.primary"}
              >
                {role}
              </Typography>
            }
          />
        </ListItem>
      </List>
    </Box>
  );
};

Information.propTypes = {
  userData: PropTypes.shape({}).isRequired,
};

export default Information;
